import { LoadingOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import React, { useMemo, useState } from "react";
import { IArticle } from "../../api/blog-api";
import { getArticles } from "../../api/fire-article";
import DesignCard from "../../components/design-card/design-card";
import "./designs-page.scss";

export interface DesignsPageProps {}

export const DesignsPage: React.FC<DesignsPageProps> = () => {
  const [data, setData] = useState<IArticle[]>([]);
  const [loading, setLoading] = useState(true);
  useMemo(
    () =>
      getArticles().then((d) => {
        setLoading(false);
        setData(d);
      }),
    []
  );

  return (
    <Row className="" gutter={[32, 16]}>
      {!loading && data ? (
        data.map((x, i) => (
          <Col xs={24} md={12} key={i}>
            <DesignCard {...x} />
          </Col>
        ))
      ) : (
        <LoadingOutlined />
      )}
    </Row>
  );
};

export default DesignsPage;
